module.exports = __webpack_public_path__ + "./images/2f34d429e45e7d2007f3c560fbc26562.jpg";